/* tslint:disable */
/* eslint-disable */
/**
 * Dataland API key manager API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { ApiKeyAndMetaInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/apikeymanager/model';
// @ts-ignore
import type { ApiKeyMetaInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/apikeymanager/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/apikeymanager/model';
// @ts-ignore
import type { RevokeApiKeyResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/apikeymanager/model';
/**
 * ApiKeyControllerApi - axios parameter creator
 */
export const ApiKeyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates and persists a new API key for the requesting user with an expiry date based on the number of valid days in the request param.
         * @summary Generate a new API key.
         * @param {number} [daysValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey: async (daysValid?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generateApiKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (daysValid !== undefined) {
                localVarQueryParameter['daysValid'] = daysValid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets meta info about the API key status of a user based on the Keycloak user ID.
         * @summary Get API key meta info of a specific user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyMetaInfoForUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getApiKeyMetaInfoForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if API key exists in storage for the requesting user and revokes it. If there is no API key registered for the user, this is reported in the response.
         * @summary Revoke an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiKey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/revokeApiKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if an API key is valid and returns the validation results together with its meta info.
         * @summary Validate an API key.
         * @param {string} apiKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApiKey: async (apiKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKey' is not null or undefined
            assertParamExists('validateApiKey', 'apiKey', apiKey)
            const localVarPath = `/validateApiKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiKey !== undefined) {
                localVarQueryParameter['apiKey'] = apiKey;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeyControllerApi - functional programming interface
 */
export const ApiKeyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiKeyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates and persists a new API key for the requesting user with an expiry date based on the number of valid days in the request param.
         * @summary Generate a new API key.
         * @param {number} [daysValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateApiKey(daysValid?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyAndMetaInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateApiKey(daysValid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyControllerApi.generateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets meta info about the API key status of a user based on the Keycloak user ID.
         * @summary Get API key meta info of a specific user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeyMetaInfoForUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyMetaInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeyMetaInfoForUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyControllerApi.getApiKeyMetaInfoForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if API key exists in storage for the requesting user and revokes it. If there is no API key registered for the user, this is reported in the response.
         * @summary Revoke an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeApiKey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeApiKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyControllerApi.revokeApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if an API key is valid and returns the validation results together with its meta info.
         * @summary Validate an API key.
         * @param {string} apiKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateApiKey(apiKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyMetaInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateApiKey(apiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyControllerApi.validateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiKeyControllerApi - factory interface
 */
export const ApiKeyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiKeyControllerApiFp(configuration)
    return {
        /**
         * Generates and persists a new API key for the requesting user with an expiry date based on the number of valid days in the request param.
         * @summary Generate a new API key.
         * @param {number} [daysValid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(daysValid?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyAndMetaInfo> {
            return localVarFp.generateApiKey(daysValid, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets meta info about the API key status of a user based on the Keycloak user ID.
         * @summary Get API key meta info of a specific user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyMetaInfoForUser(options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyMetaInfo> {
            return localVarFp.getApiKeyMetaInfoForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if API key exists in storage for the requesting user and revokes it. If there is no API key registered for the user, this is reported in the response.
         * @summary Revoke an existing API key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeApiKey(options?: RawAxiosRequestConfig): AxiosPromise<RevokeApiKeyResponse> {
            return localVarFp.revokeApiKey(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if an API key is valid and returns the validation results together with its meta info.
         * @summary Validate an API key.
         * @param {string} apiKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApiKey(apiKey: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyMetaInfo> {
            return localVarFp.validateApiKey(apiKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiKeyControllerApi - interface
 */
export interface ApiKeyControllerApiInterface {
    /**
     * Generates and persists a new API key for the requesting user with an expiry date based on the number of valid days in the request param.
     * @summary Generate a new API key.
     * @param {number} [daysValid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateApiKey(daysValid?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyAndMetaInfo>;

    /**
     * Gets meta info about the API key status of a user based on the Keycloak user ID.
     * @summary Get API key meta info of a specific user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApiKeyMetaInfoForUser(options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyMetaInfo>;

    /**
     * Checks if API key exists in storage for the requesting user and revokes it. If there is no API key registered for the user, this is reported in the response.
     * @summary Revoke an existing API key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeApiKey(options?: RawAxiosRequestConfig): AxiosPromise<RevokeApiKeyResponse>;

    /**
     * Checks if an API key is valid and returns the validation results together with its meta info.
     * @summary Validate an API key.
     * @param {string} apiKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateApiKey(apiKey: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyMetaInfo>;

}

/**
 * ApiKeyControllerApi - object-oriented interface
 */
export class ApiKeyControllerApi extends BaseAPI implements ApiKeyControllerApiInterface {
    /**
     * Generates and persists a new API key for the requesting user with an expiry date based on the number of valid days in the request param.
     * @summary Generate a new API key.
     * @param {number} [daysValid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateApiKey(daysValid?: number, options?: RawAxiosRequestConfig) {
        return ApiKeyControllerApiFp(this.configuration).generateApiKey(daysValid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets meta info about the API key status of a user based on the Keycloak user ID.
     * @summary Get API key meta info of a specific user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApiKeyMetaInfoForUser(options?: RawAxiosRequestConfig) {
        return ApiKeyControllerApiFp(this.configuration).getApiKeyMetaInfoForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if API key exists in storage for the requesting user and revokes it. If there is no API key registered for the user, this is reported in the response.
     * @summary Revoke an existing API key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeApiKey(options?: RawAxiosRequestConfig) {
        return ApiKeyControllerApiFp(this.configuration).revokeApiKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if an API key is valid and returns the validation results together with its meta info.
     * @summary Validate an API key.
     * @param {string} apiKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateApiKey(apiKey: string, options?: RawAxiosRequestConfig) {
        return ApiKeyControllerApiFp(this.configuration).validateApiKey(apiKey, options).then((request) => request(this.axios, this.basePath));
    }
}

